import { SignIn, useAuth } from '@clerk/clerk-react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Loader2 } from 'lucide-react';
import React from 'react';
import { z } from 'zod';

const loginSearchSchema = z.object({
  redirect: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/login/$')({
  validateSearch: loginSearchSchema,
  component: LoginComponent,
});

function LoginComponent() {
  const navigate = useNavigate({ from: Route.fullPath });
  const { isSignedIn, isLoaded } = useAuth();
  const { redirect } = Route.useSearch(); // Now correctly typed

  React.useEffect(() => {
    if (isLoaded && isSignedIn) {
      const redirectTo = redirect || '/';
      navigate({ to: redirectTo, replace: true });
    }
  }, [isSignedIn, isLoaded, navigate, redirect]);

  if (!isLoaded) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Loader2 className="h-12 w-12 animate-spin text-primary" />
      </div>
    );
  }

  if (!isSignedIn) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-background p-4">
        <SignIn
          routing="path" // Use path-based routing
          path="/login" // Current path for sign-in
          signUpUrl="/sign-up" // URL for the sign-up page
          forceRedirectUrl={redirect || '/dashboard'} // Redirect after successful sign-in
          // afterSignInUrl and afterSignUpUrl are deprecated in favor of forceRedirectUrl or navigation via callbacks
        />
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center h-screen">
      <p>Redirecting...</p>
      <Loader2 className="h-8 w-8 animate-spin text-primary ml-2" />
    </div>
  );
}
